import { Close } from "@mui/icons-material";
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, LinearProgress, Paper, Typography } from "@mui/material";
import { useState } from "react";
import { NavButton } from "../../components/NavLink";
import { useCachedStore, useRemoteData } from "../../models/Hooks";
import Proxy, { root } from "../../models/Proxy";
import { Post } from "../../models/Types";
import { getTheme } from "../../theme";
import { configureSuggestStore } from "../../components/form/RemoteCombo";
import CachedStore from "../../models/CachedStore";

const styles = {
    carousel: {
        overflowX: 'auto',
        py: 1,
    },
    wrappper: {
        display: 'flex',
        overflow: 'hidden',
        gap: 1
    },
    paper: {
        width: 100,
        height: 100,
        minWidth: 100,
        p: .5,
        m: 0,
        backgroundSize: 'cover',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end'
    },
    dialog: {
        width: '100%',
        height: '100%',
        maxHeight: '100%',
        borderRadius: 0,
        backgroundColor: 'rgba(255,255,255,.3)',
        backdropFilter: 'blur(10px)',
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        display: 'flex',
        m: 0,
        flexDirection: 'column',
        justifyContent: 'space-between'
    },
    closeBtn: {
        position: 'absolute',
        right: 0,
        top: 0,
    },
    dialogTitle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        position: 'relative',
        p: 1.5
    },
    paperBox: {
        m: .1,
        p: '2px',
        borderWidth: 2,
        borderStyle: 'solid',
        borderColor: 'transparent',
        borderRadius: 3
    },
    paperBoxUnwatched: {
    }
}
styles.paperBoxUnwatched = { ...styles.paperBox, ...styles.paperBoxUnwatched };

var watched: number[] = localStorage.getItem('watchedStories')?.split(',').map(x => parseInt(x)) || [];

const postStoriesStore = CachedStore.Configure<Post>('PostStories', 'PostStories', 30 * 60);
export default function PostStories() {
    const [data] = useCachedStore(postStoriesStore, undefined, true);
    const [sel, setSel] = useState<Post>();
    const [loading, setLoading] = useState<boolean>();

    if (!data?.length) {
        return <></>;
    }

    return <>
        <Box sx={styles.carousel} >
            <table cellSpacing={0}>
                <tbody >
                    <tr>
                        {data.map(x => <td><Box sx={styles.paperBox} style={!watched.includes(x.Id) ? { borderColor: getTheme().palette.primary.light } : null}>
                            <Paper key={x.Id}
                                onClick={() => {
                                    setSel(x);
                                    setLoading(true);
                                    Proxy.get('PostGet?id=' + x.Id).then(x => {
                                        setSel(x.result);
                                        setLoading(false);
                                    });

                                    if (!watched.includes(x.Id)) {
                                        watched.push(x.Id);
                                        localStorage.setItem('watchedStories', watched.join(','));
                                    }
                                }}
                                sx={styles.paper}
                                style={{ backgroundImage: `url(${root}files/${x.StoryImage})` }}>
                                <Typography variant="h5" sx={{ color: 'white' }}>{x.Name}</Typography>
                            </Paper>
                        </Box></td >)}
                    </tr>
                </tbody>
            </table>
        </Box>

        <Dialog open={!!sel} PaperProps={{ sx: styles.dialog, style: { backgroundImage: `url(${root}files/${sel?.StoryImage})` } }}>
            <DialogTitle sx={styles.dialogTitle}>
                {loading ? <LinearProgress sx={{ p: 0 }} style={{ opacity: 1, position: "absolute", width: '200%', top: 0, left: '-50%' }} /> : null}
                <Typography>{sel?.Name}</Typography>
                <IconButton onClick={() => setSel(undefined)}><Close /></IconButton>
            </DialogTitle>
            <div style={{ flex: 1 }} />
            <DialogContent sx={{ flex: 'none', maxHeight: '15%' }}>
                <Typography component="div" variant="caption" dangerouslySetInnerHTML={{ __html: sel?.Body }} />
            </DialogContent>
            <DialogActions sx={{ backgroundColor: getTheme()?.palette.background.paper }}>
                <NavButton variant="contained" size="small" route={[['page', 'news'], ['id', sel?.Id]]}>Подробнее</NavButton>
            </DialogActions>
        </Dialog>
    </>;
}